import Collection from '../collection';
import Comment from '../model/comment';

import { get, } from '../http/api';





export const Comments = Collection.extend( {
    model: Comment,
    responseAt: 'comments'
} );

export const fetch = function(taskId, limit = 1000000) {
    return get( `tasks/${taskId}/comments/list?limit=${limit}&apiVersion=1.3` )
        .cerebellum().hidden()
        .map( response => response.comments )
        .execute()
        .then( items => new Comments( items ) )
        .then( coll => [coll.toJSON(), coll] );
};


// WEBPACK FOOTER //
// ./src/js/collection/comments.js